<template>
  <v-container fluid>
    <p v-if="this.$store.state.clubTournaments.length === 0" class="text-center" style="margin-top: 30%">
      <v-btn v-if="this.$store.state.clubMember.rol !== 'MEMBER'" class="button-add mb-5 mt-n5"
             @click="addTournament">{{ $t('btnAddFirst') }}<v-icon class="icon ml-2" color="white" small>fa-plus</v-icon>
      </v-btn>
      <br>
      {{ $t('noTournaments') }}
    </p>

    <div v-else>
      <v-container fluid>
        <h2>
          {{ $t('title') }}
          <v-btn v-if="this.$store.state.clubMember.rol !== 'MEMBER'" class="button-add ml-4" @click="addTournament">
            {{ $t('btnAdd') }}</v-btn>
        </h2>
        <v-row class="mt-3">
          <v-col cols="3" :key="tournament.id" v-for="tournament in this.$store.state.clubTournaments">
            <v-card @click="goToTournament(tournament)" class="overall-card d-flex align-center" outlined>
              <v-card-text class="pa-5">
                <div>
                  <v-chip :color="tournamentStatusColor(tournament)" class="mb-2" small>{{ tournamentStatus(tournament) }}</v-chip>
                  <v-chip :color="tournamentVisibilityColor(tournament.tournamentVisibility)" class="ml-1 mb-2" small>{{ tournamentVisibility(tournament) }}</v-chip>
                  <h3 class="tournament-head">{{ truncateString(tournament.name) }}</h3>
                  <p class="content mb-n2">{{ truncateString(tournament.creator.name, 50) }}</p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-overlay v-model="overlayAddTournament">
      <AddTournament :featurePermissionInfo="featurePermissionInfo" @closeWindow="overlayAddTournament = false"/>
    </v-overlay>

    <v-overlay v-model="overlayUnavailableFeature">
      <UnavailableFeature :hasCloseWindowAction="true" @closeWindow="overlayUnavailableFeature = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import AddTournament from "@/views/Community/components/AddTournament";
import Repository from '../../../repositories/tournament';
import UnavailableFeature from './UnavailableFeature';
import { mapMutations } from 'vuex';
export default {
  name: "ClubTournaments",
  components: {AddTournament, UnavailableFeature},
  data() {
    return {
      overlayAddTournament: false,
      overlayUnavailableFeature: false,
      isFeatureUnavailable: true,
      featurePermissionInfo: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(['setClubTournaments']),
    init() {
      Repository.getTournamentsByClubId(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400)
          this.setClubTournaments(response.data);
      });
      this.validateFeatureAvailable();
    },
    validateFeatureAvailable() {
      let permissions = this.$store.state.clubPermissions;
      for(let permission of permissions) {
        if(permission.clubFeature.name == 'TOURNAMENT_CREATION') {
          this.isFeatureUnavailable = false;
          this.featurePermissionInfo = permission;
          break;
        }
      }
    },
    addTournament() {
      if (this.isFeatureUnavailable) {
        this.overlayUnavailableFeature = true;
      } else {
        this.overlayAddTournament = true;
      }
    },
    tournamentVisibility(tournament) {
      return tournament.tournamentVisibility === 'PUBLIC'? this.$t('visibility.public') :
          tournament.tournamentVisibility === 'PRIVATE'? this.$t('visibility.private') : this.$t('visibility.exclusive');
    },
    tournamentStatus(tournament) {
      let now = new Date();
      if(new Date(tournament.endTime) < now)
        return this.$t('status.finished');
      else if(new Date(tournament.startTime) > now)
        return this.$t('status.planning');
      else
        return this.$t('status.running');
    },
    tournamentStatusColor(tournament) {
      let now = new Date();
      if(new Date(tournament.endTime) < now)
        return '#D1D1D1';
      else if(new Date(tournament.startTime) > now)
        return '#FFF75F';
      else
        return '#00F784';
    },
    tournamentVisibilityColor(visibility) {
      switch (visibility) {
        case 'PUBLIC':
          return '#FFF75F';
        case 'PRIVATE':
          return '#66c3d0';
        default:
          return '#d1d1d1';
      }
    },
    goToTournament(tournament) {
      this.$router.push({
        name: 'tournament-overview',
        params: { tournamentId: Number.parseInt(tournament.id) }
      });
    },
    truncateString(string, maxLength) {
      return (string !== null && string.length > maxLength)? `${string.substring(0, maxLength)}...`: string;
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": " Community Tournaments",
    "btnAdd": "Create Tournament",
    "btnAddFirst": "Create First Tournament",
    "visibility": {
      "public": "Public",
      "private": "Private",
      "exclusive": "Exclusive"
    },
    "status": {
      "planning": "Planning",
      "running": "Running",
      "finished": "Finished"
    },
    "noTournaments": "There's no tournaments yet in this community :("
  },
  "es": {
    "title": " Torneos de Comunidad",
    "btnAdd": "Crear Torneo",
    "btnAddFirst": "Crear Primer Torneo",
    "visibility": {
      "public": "Público",
      "private": "Privado",
      "exclusive": "Exclusivo"
    },
    "status": {
      "planning": "Planeando",
      "running": "Corriendo",
      "finished": "Finalizado"
    },
    "noTournaments": "Aún no hay torneos en esta comunidad :("
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";

  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }

  .tournament-head {
    color: $black-color;
    font-size: 25px;
  }
</style>
